const displayType = (state = {}, action) => {
    let localState = state;
    switch (action.type) {
        case 'SET_DISPLAY_VALUE':
            localState = action.data;
            return localState;
        default:
            return localState;
    }
};

export default displayType;